/*
|-------------------------------------------------------------------------------
| Vuex modules/search.js
|-------------------------------------------------------------------------------
| Vuex data store for search view
*/

import SearchAPI from '@/api/search.js';

export const search = {
    state: {
        isLoading: {
            atcCodes: false,
            substances: false,
            vnrs: false,
            companies: false,
            products: false,
        },

        countries: [],
        regions: [],
        bricks: [],

        atcCodes: [],
        substances: [],
        products: [],

        formulations: [],
        strengths: [],
        sizes: [],

        vnrs: [],
        companies: [],
    },
    actions: {
        /*
		    GET   /api/v1/search/regions/{country_id}
	    */
        // async loadRegions({ commit }, countryId) {
        //     try {
        //         const { data } = await SearchAPI.getRegions(countryId);
        //         commit('SET_REGIONS', data.regions);
        //     } catch (error) {
        //         console.error(error);
        //         commit('SET_REGIONS', []);
        //     }
        // },

        // loadRegions({ commit }, countryId) {
        //     return SearchAPI.getRegions(countryId)
        //         .then(({ data }) => {
        //             commit('SET_REGIONS', data.regions);
        //         })
        //         .catch((error) => {
        //             console.error(error);
        //             commit('SET_REGIONS', []);
        //         });
        // },

        /*
	        GET   /api/v1/search/bricks/{country_id}/{region_id}
	    */
        // async loadBricks({ commit }, { countryId, regionId }) {
        //     try {
        //         const { data } = await SearchAPI.getBricks(countryId, regionId);
        //         commit('SET_BRICKS', data.bricks);
        //     } catch (error) {
        //         console.error(error);
        //         commit('SET_BRICKS', []);
        //     }
        // },

        /*
		    GET   /api/v1/search/atc_codes/{atc_code}
	    */
        // loadAtcCodes({ commit, state }, params) {
        //     // Items have already been loaded
        //     if (params !== null && params.length < 2) return;

        //     // Items have already been requested
        //     if (state.isLoading.atcCodes) return;

        //     state.isLoading.atcCodes = true;

        //     SearchAPI.getAtcCodes(params)
        //         .then((response) => {
        //             commit('SET_ATC_CODES', response.data);
        //         })
        //         .catch((error) => {
        //             console.error(error);
        //             commit('SET_ATC_CODES', []);
        //         })
        //         .finally(() => (state.isLoading.atcCodes = false));
        // },

        /*
		    GET   /api/v1/search/substances/{substance}
	    */
        // loadSubstances({ commit, state }, params) {
        //     // Items have already been loaded
        //     if (params !== null && params.length < 2) return;

        //     // Items have already been requested
        //     if (state.isLoading.substances) return;

        //     state.isLoading.substances = true;

        //     SearchAPI.getSubstances(params)
        //         .then((response) => {
        //             // Sum object property values that have the same key
        //             // const counts = response.data.reduce((prev, curr) => {
        //             //     const count = prev.get(curr.text) || '';
        //             //     prev.set(curr.text, [curr.id, ...count]);
        //             //     return prev;
        //             // }, new Map());

        //             // const reducedObjArr = [...counts].map(([text, id]) => {
        //             //     return { text, id };
        //             // });

        //             commit('SET_SUBSTANCES', response.data);
        //         })
        //         .catch((error) => {
        //             console.error(error);
        //             commit('SET_SUBSTANCES', []);
        //         })
        //         .finally(() => (state.isLoading.substances = false));
        // },

        /*
            GET   /api/v1/search/proudcts/{product}
	    */
        // loadProducts({ commit, state }, params) {
        //     // Items have already been loaded
        //     if (params !== null && params.length < 2) return;

        //     // Items have already been requested
        //     if (state.isLoading.products) return;

        //     state.isLoading.products = true;

        //     SearchAPI.getProducts(params)
        //         .then((response) => {
        //             commit('SET_PRODUCTS', response.data);
        //         })
        //         .catch((error) => {
        //             console.error(error);
        //             commit('SET_PRODUCTS', []);
        //         })
        //         .finally(() => (state.isLoading.products = false));
        // },

        // /*
		//     GET   /api/v1/search/vnrs/{vnr}
	    // */
        // loadVnrs({ commit, state }, params) {
        //     // Items have already been loaded
        //     if (params !== null && params.length < 2) return;

        //     // Items have already been requested
        //     if (state.isLoading.vnrs) return;

        //     state.isLoading.vnrs = true;

        //     SearchAPI.getVnrs(params)
        //         .then((response) => {
        //             commit('SET_VNRS', response.data);
        //         })
        //         .catch((error) => {
        //             console.error(error);
        //             commit('SET_VNRS', []);
        //         })
        //         .finally(() => (state.isLoading.vnrs = false));
        // },

        // /*
		//     GET   /api/v1/search/companies/{company}
	    // */
        // loadCompanies({ commit, state }, params) {
        //     // Items have already been loaded
        //     if (params !== null && params.length < 2) return;

        //     // Items have already been requested
        //     if (state.isLoading.companies) return;

        //     state.isLoading.companies = true;

        //     SearchAPI.getCompanies(params)
        //         .then((response) => {
        //             commit('SET_COMPANIES', response.data);
        //         })
        //         .catch((error) => {
        //             console.error(error);
        //             commit('SET_COMPANIES', []);
        //         })
        //         .finally(() => (state.isLoading.companies = false));
        // },
    },
    mutations: {
        // Set regions
        SET_REGIONS(state, payload) {
            state.regions = payload;
        },

        // Set bricks
        SET_BRICKS(state, payload) {
            state.bricks = payload;
        },

        // Set ATC Codes
        SET_ATC_CODES(state, payload) {
            // Check if atc codes has saved searches
            if (payload === undefined || payload.length == 0) {
                state.atcCodes = [];
            }

            if (state.atcCodes.length) {
                state.atcCodes = state.atcCodes.concat(payload);
            } else {
                state.atcCodes = payload;
            }
        },

        // Set substances
        SET_SUBSTANCES(state, payload) {
            // Check if atc codes has saved searches
            if (payload === undefined || payload.length == 0) {
                state.substances = [];
            }

            // Maybe do spread ... ?
            if (state.substances.length) {
                state.substances = state.substances.concat(payload);
            } else {
                state.substances = payload;
            }
        },

        // Set products
        SET_PRODUCTS(state, payload) {
            // Check if products has saved searches
            if (payload === undefined || payload.length === 0) {
                state.products = [];
            }

            if (state.products.length) {
                state.products = [...payload];
            } else {
                state.products = payload;
            }
        },

        // Set VNRs
        SET_VNRS(state, payload) {
            // Check if vnrs has saved searches
            if (payload === undefined || payload.length == 0) {
                state.vnrs = [];
            }

            if (state.vnrs.length) {
                state.vnrs = state.vnrs.concat(payload);
            } else {
                state.vnrs = payload;
            }
        },

        // Set companies
        SET_COMPANIES(state, payload) {
            // Check if companies has saved searches
            if (payload === undefined || payload.length == 0) {
                state.companies = [];
            }

            if (state.companies.length) {
                state.companies = state.companies.concat(payload);
            } else {
                state.companies = payload;
            }
        },
    },
    getters: {
        // Get regions
        getRegions: (state) => state.regions,

        // Get bricks
        getBricks: (state) => state.bricks,

        // Get ATC Codes
        getAtcCodes: (state) => state.atcCodes,

        // Get substances
        getSubstances: (state) => state.substances,

        // Get products
        getProducts: (state) => state.products,

        // Get VNRs
        getVnrs: (state) => state.vnrs,

        // Get companies
        getCompanies: (state) => state.companies,

        getIsLoadingAtcCodes: (state) => state.isLoading.atcCodes,
        // Get loading state
        getIsLoadingSubstances: (state) => state.isLoading.substances,
        getIsLoadingProducts: (state) => state.isLoading.products,
        getIsLoadingVnrs: (state) => state.isLoading.vnrs,
        getIsLoadingCompanies: (state) => state.isLoading.companies,
    },
};
